<template>
  <div class="over">
    <div class="header">
      <top-component ref="topRef" :datalogintype="1"></top-component>
      <div class="header_sousuo">
        <div style="width:100%;display:flex;margin-bottom: 10px; align-items: center; margin-top: 20px;">
          <div style="width:30%; display: flex; align-items: end; margin-bottom: 8px;">
            <img style="width:58px;display:block; margin-right: 15px;" src="../../assets/images/shuxiang.png" alt="">
            <div style="font-size: 40px;">云田购</div>
          </div>
          <div style="width:70%;margin-top:1%">
            <div class="searchcontainer">
              <input type="text" v-model="searchTerm" placeholder="请输入搜索内容">
              <div
                style="width: 100px;height:41px;text-align:center;line-height:41px;background-color:#CA1A1B;color:#fff;font-size:14px;cursor: pointer;"
                @click="toSearchListCopy(searchTerm)">
                查询</div>

            </div>
            <div style="width:92%;display:flex;justify-content: space-between;">
              <div style="color: #969696;margin-right: 15px;height: 20px;overflow: hidden;font-size:13px;cursor: pointer;
                width:70%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;
                ">
                热搜:
                <span v-for="(item,index) in overlistbanner.hotwords" :key="index"
                  @click="toSearchListCopy(item)">&nbsp; {{item}} </span>
              </div>
              <div
                style="color: #969696;margin-right: 15px;height: 20px;overflow: hidden;font-size:13px;cursor: pointer;"
                @click="toSearchList()">
                高级查询</div>
            </div>

          </div>
        </div>
        <div style="display:flex;width:100%;margin-top:30px">
          <div
            style="min-width:24%;height:40px;background-color:#CA1A1B;font-size:15px;font-weight: 500;line-height: 40px;color: #fff; text-indent: 0.5em;font-weight: 700;margin-top:10px">
            全部分类
          </div>
          <div
            style="display:flex;justify-content: space-between;width:25%;line-height:40px;margin-left:15px;height:40px;margin-top:10px;">
            <div v-for="(item,index) in carouselAfter" :key="item.tagid || index"
              @click="TESEtuijianTo(item.tagid, item.tagname)" class="tuijian">
              {{item.tagname}}
            </div>
          </div>

        </div>

      </div>

    </div>

    <div class="shenzi">
      <div style="display:flex;height:405px;position: relative;">
        <div class="oneclass" style="display:flex" @mouseover="jinru" @mouseout="yichu">
          <div class="oneclass_kuai">
            <div class="oneclass_xuanz">
              <div :class="oneclassState==item.name?'oneclass_classon':'oneclass_class'    "
                @click="xuanzefenlei(item.name)" v-for="(item,index) in fenleiList" :key="index">
                <span style="display:block">{{item.name}}</span>
                <i class="el-icon-caret-bottom" style="padding-top:13px" v-show="oneclassState==item.name"></i>
              </div>
            </div>
            <el-skeleton :rows="8" animated v-if="GuJiaPing" />
            <div style="width:100%;max-height:200px;cursor: pointer;" v-else>
              <div :class="zibiaoqianList.name==item.name?'oneclass_yijion':'oneclass_yiji'    "
                v-for="(item,index) in classList" :key="index" @mouseover="shangxiahuadong(item)"
                @click="ChinesClick(item,oneclassState)">
                <div style="display:flex">
                  <div style="font-size:13px">{{item.classifyTypeCode}}&nbsp;</div>
                  <div class="typenames">
                    {{item.name}}</div>
                </div>
                <div style="display:flex;margin-top:10px;">
                  <div style="display:flex;margin-right:10px;font-size:12px;margin-top:1px"
                    v-for="(O,I) in item.cHildrenCopy" :key="I">
                    [{{O.classifyTypeName}}]
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div
            style="width:76%;height:411px;background-color:#fbfbfb;position: absolute;z-index: 100000;left: 24%;-webkit-box-shadow: 2px 0 5px rgba(0,0,0,.1);box-shadow: 2px 0 5px rgba(0,0,0,.1);-webkit-transition: top .25s ease;transition: top .25s ease;"
            v-show="twoclassstate">
            <div class="fudong_text">
              {{zibiaoqianList.name}}
              <i class="el-icon-caret-bottom"></i>
            </div>
            <div class="fudong_textneirong">
              <div class="textneirong" v-for="(item,index) in zibiaoqianList.children" :key="index"
                @click="erjitiaozhuan(item)">
                {{item.classifyTypeName}}
              </div>
            </div>
          </div>
        </div>

        <div class="shenzi_left">
          <el-skeleton :rows="11" animated v-if="!overlistbanner.banner || overlistbanner.banner.length === 0" />

          <el-carousel height="410px" class="banner-box" :interval="3000" v-else>
            <el-carousel-item v-for="(item,index) in overlistbanner.banner" :key="index">
              <img :src="item.bannerurl" @click="TESEtuijianTo(item.pkid, item.shudanmingcheng,'ad'+ item.pkid )"
                style="cursor: pointer; width: 100%; height: 100%;" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <el-skeleton :rows="11" animated v-if="areaLoading" />

      <!-- 图书馆专属书单(privateArea) 已通过 computed 排到轮播图正下方、最显眼；
           公共分类(tileArea) 紧随其后。两者复用同一套原版样式：无子分类=原新书推荐区，有子分类=原最新上架大分类区 -->
      <template v-for="area in homeContentAreas">
        <div class="zdtj" v-if="!hasAreaChildren(area)" :key="'plain-' + area.tagid">
          <div style="display:flex;    justify-content: space-between;">
            <div class="zdtj_next">
              <img style="width: 23px; height: 23px;" src="../../assets/images/fl1.png" alt="">
              {{area.tagname}}
            </div>
            <div class="sjemzo_right_new_overon" @click="TESEtuijianTo(area.tagid,area.tagname)">
              查看全部>
            </div>
          </div>
          <div class="zdtj_overlist">
            <div class="zdtj_overlist_list" v-for="(item,index) in area.goods" :key="item.goodsId || index"
              @click="BookTuiClickRowid(item.goodsId,area.tagid)">
              <span class="orderedTip" v-if="item.selectNum>0">{{adminState1 == '0' || adminState1 == '1' ? '已订购' :
                '已荐购'}}</span>
              <img
                style="width: 100px;height: 140px;cursor: pointer;margin-top: 20px;border-radius: 5px;margin-bottom: 15px;"
                :src="item.imageUrl" alt="">
              <div style="line-height: 20px;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: bold;
                width: 80%;
                padding: 0px 10%;
                margin-bottom: 5px;" :title="item.title">
                {{item.title}}</div>
              <div class="box_list"
                style="font-size: 12px;max-height: 20px;overflow: hidden;line-height: 20px;text-overflow: ellipsis;white-space: nowrap;">
                {{item.author}}</div>
              <div class="box_list">{{item.publisher}}</div>
              <div class="box_list">{{item.publishTime}}</div>
              <div class="box_list">￥{{item.price}}</div>
              <div class="box_list">(总订购{{item.allNum}}次)</div>
              <div class="buttonDiv">
                <el-button v-if="adminState1 == 0 || adminState1 == 1" type="warning" plain
                  @click.stop="multiAdd(item.goodsId,area.areaType)" size="mini">加入购物车</el-button>
                <el-button v-else type="warning" plain @click.stop="multiAdd(item.goodsId,area.areaType)" size="mini">{{
                  isRmdPost ? '荐购直邮' : '荐购' }}</el-button>
              </div>
            </div>
          </div>
        </div>

        <div class="zxsj" v-else :key="'children-' + area.tagid">
          <div class="zxsj_top">
            <div class="zdtj_next">
              {{area.tagname}}
            </div>
            <i class="icon iconfont iconarrowleft" style="line-height: 50px;" @click="scrollAreaChildren(area.tagid, -1)"></i>
            <div class="levelClass" :ref="'areaLevelClass-' + area.tagid">
              <div :class="(activeChild[area.tagid] || 0)==index?'levelClass_liston':'levelClass_list' "
                v-for="(item,index) in area.children" :key="item.tagid || index"
                @mouseover="selectChild(area,item,index)" @click="TESEtuijianTo(item.tagid,item.tagname)">
                {{item.tagname}}
              </div>
            </div>
            <i class="icon iconfont iconarrowright" style="line-height: 50px;" @click="scrollAreaChildren(area.tagid, 1)"></i>
          </div>
          <div class="zxsj_list">
            <div class="zxsj_list_over" v-for="(item,index) in getBlockGoods(area)" :key="item.goodsId || index"
              @click="BookTuiClickRowid(item.goodsId)">
              <span class="orderedTip" v-if="item.selectNum>0">{{adminState1 == '0' || adminState1 == '1' ? '已订购' :
                '已荐购'}}</span>
              <img style="height: 156px;width: 116px;border-radius: 5px;margin: 0 20px;margin-top:30px"
                :src="item.imageUrl" alt="">
              <div class="zxsj_list_over_right">
                <div class="class1" :title="item.title"
                  style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;">{{item.title}}</div>
                <div class="class2">{{item.author}}</div>
                <div class="zxsj_text">{{item.publisher}}</div>
                <div class="zxsj_text">{{item.publishTime}}</div>
                <div class="zxsj_text">￥{{item.price}}</div>
                <div class="zxsj_text">(总订购{{item.allNum}}次)</div>
                <div class="buttonDiv">
                  <el-button v-if="adminState1 == 0 || adminState1 == 1" type="warning" plain
                    @click.stop="multiAdd(item.goodsId,area.areaType)" size="mini">加入购物车</el-button>
                  <el-button v-else type="warning" plain @click.stop="multiAdd(item.goodsId,area.areaType)" size="mini">{{
                    isRmdPost ? '荐购直邮' : '荐购' }}</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>



      <!-- <div class="zxsj" >
        <div class="zxsj_top">
          <div class="zdtj_next">
            测试
          </div>
          <i class="icon iconfont iconarrowleft" style="line-height: 50px;" @click="preList('ulWrap')"></i>
          <div class="levelClass">
            <div :class="index==leveListindex?'levelClass_liston':'levelClass_list' "
              v-for="(item,index) in overlistbanner.classList" :key='index' @mouseover='jingguo(item,index)'
              @click="ChinesClick(item,'中图法分类')">
              {{item.classifyTypeName}}
            </div>
          </div>
          <i class="icon iconfont iconarrowright" style="line-height: 50px;" @click="nextList('ulWrap')"></i>
          <div class="sjemzo_right_new_overon" @click="TESEtuijianTo(item.shudanerpid,item.shudanmingcheng)">
            查看全部>
          </div> 
        </div>
        <div class="zdtj_overlist">
          <div class="zdtj_overlist_list" v-for="(item,index) in zxList" :key="index"
            @click="BookTuiClickRowid(item.goodsId)">
              <img
              style="width: 100px;height: 140px;cursor: pointer;margin-top: 20px;border-radius: 5px;margin-bottom: 15px;"
              :src="item.imageUrl" alt="">
            <div
              style="line-height: 20px;font-size: 14px;max-height: 40px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: bold;width: 80%;white-space: inherit;padding: 0 10%;margin-bottom: 5px;">
              {{item.title}}</div>
            <div class="box_list"
              style="font-size: 12px;max-height: 20px;overflow: hidden;line-height: 20px;text-overflow: ellipsis;white-space: nowrap;">
              {{item.author}}</div>
            <div class="box_list">{{item.publisher}}</div>
            <div class="box_list">{{item.publishTime}}</div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div>  
      <el-dialog
        style="z-index: 100000;"
        :visible.sync="erweima"
        width="20%"
        :show-footer="false"
        class="centered-dialog">
        <div style="display:flex ; justify-content: center; align-items: center; flex-direction: column; width: 100%; height: 100%;">
        <img alt="example" style="width: 225px; height: 225px;" src="../../assets/images/gh_9466731f8652_258 (1).jpg" />
        <div style="font-size:18px; margin-top: 15px;font-family: serif;">微信扫描二维码</div>
        </div>
      </el-dialog>
      <el-dialog
        style="z-index: 100000;"
        :visible.sync="contactusphone"
        width="20%"
        :show-footer="false"
        class="centered-dialog">
        <div style="display:flex ; justify-content: center; align-items: center; flex-direction: column; width: 100%; height: 100%;">
        <div style="font-size: 20px;">027-51850968</div>
        <div style="font-size:18px; margin-top: 15px;">客服热线</div>
        </div>
      </el-dialog>
    </div>
    <div class="sidenavigationbar">
      <div class="sidenavigationbaritem"  @click="showerweima()" >
          <img style="width:50px" src="../../assets/images/erwe2.png" alt="">
            <span style="display: block;font-family:'Alimama'">移动端选书</span>
      </div>
      <div class="sidenavigationbaritem"  @click="contactus()" >
        <img style="width:50px" src="../../assets/images/5e9f2b1b0da09ac3b3961378284ef2d4.png" alt="">
          <span style="display: block;font-family:'Alimama'">联系我们</span>
    </div>
      <div class="sidenavigationbaritem"   @click="ProblemReport()" >
        <img style="width:50px; height: 50px;" title="问题反馈" src="../../assets/images/fankui.jpg" alt="">
        <span style="display: block;font-family:'Alimama';">问题反馈</span>
    </div>
    </div> -->
    <!-- 荐购规则弹窗：登录机构为江西财经大学图书馆时显示 -->
    <jiangou-rule-dialog :visible.sync="jiangouRuleVisible"></jiangou-rule-dialog>

    <bottom-component></bottom-component>

  </div>
</template>
<script>
  import { listclassifyTypes, listpopularTypes, searchlist, homeAreaAll, getshowcarsi, getjglogin, jxcjjglogin } from '@/api/img'
  import { actionsave, addMoreOrder, getdiFangdata, getdetails, shoppingCartnum } from "@/api/pages";
  import TopComponent from '../Components/TopComponentcopy.vue';
  import BottomComponent from '../Components/BottomComponent.vue';
  import JiangouRuleDialog from '../Components/JiangouRuleDialog.vue';
   import popup from "../../common/plugin/dialog/index.js";
  import addressManage from '../Components/addressManage.vue';
  import Cookies from 'js-cookie';
  import Axios from "@/api/diyaxios";

  // 江西财经大学图书馆机构 gid
  const JXUFE_INSTITUTION_GID = '93594341819100163724492670182846'
  export default {
    data() {
      return {
        // erweima: false,  
        // contactusphone:false,
        adminState1: Cookies.get("adminState"),
        defaultAddress: '',
        isRmdPost: '',//是否荐购直邮
        GuJiaPing: true,
        Index: '中图法分类',
        searchTerm: '',
        oneclassState: '中图法分类',
        twoclassstate: false,
        newList: [
          { typeName: '精品大码洋', typeCode: '37' },
          { typeName: '建筑科学', typeCode: '41' },
          { typeName: '经济金融', typeCode: '36' },
          { typeName: '桃李寸心', typeCode: '39' },
          { typeName: '党建思政', typeCode: '34' },
        ],
        leveListindex: '0',
        leveListindexCopy: '0',
        leveListindexCopyCopy: '0',
        zxListCopy: [],
        zxListCopyCopy: [],
        logintype: Cookies.get('logintype'),
        zxList: [],
        fenleiList: [
          { name: '中图法分类' },
          { name: '学科分类' },
          { name: '大众分类' },
        ],
        classList: [],
        loading: null,
        zibiaoqianList: [],
        overlistbanner: { banner: [], hotwords: [] },
        // 首页采购分类三区域（homeAreaAll 接口）
        carouselAfter: [],   // 轮播图上方快捷分类
        tileArea: [],        // 下方公共分类区域
        privateArea: [],     // 当前机构个性化分类区域，渲染规则与 tileArea 相同
        activeChild: {},     // 有子分类的区域：当前选中的子分类下标（key=tagid）
        areaLoading: true,
        jiangouRuleVisible: false,  // 江西财经大学图书馆「荐购规则」弹窗显隐
      }
    },
    components: {
      TopComponent,
      BottomComponent,
      JiangouRuleDialog
    },
    computed: {
      // 图书馆专属书单(privateArea) 与 公共分类(tileArea) 数据结构一致、复用同一套原版样式；
      // 按需求将 privateArea 置于轮播图正下方、更加显眼，故排在 publicAreas 之前渲染
      homeContentAreas() {
        const publicAreas = (this.tileArea || []).map(item => Object.assign({ areaType: 'tileArea' }, item))
        const privateAreas = (this.privateArea || []).map(item => Object.assign({ areaType: 'privateArea' }, item))
        return privateAreas.concat(publicAreas)
      }
    },
    created() {
      if(localStorage.getItem('user')){
        this.defaultAddress = JSON.parse(localStorage.getItem('user')).address;
      }
      if(localStorage.getItem('roleInfo')){
        this.isRmdPost = JSON.parse(localStorage.getItem('roleInfo')).isdirectmail;
      }
      this.mysource1()
      this.how()
      this.zhongtufa()
    },
    async mounted() {

      this.mysource1()
      const ticket = this.getTicketFromUrl()
      if (ticket) {
        await this.showcarsi(ticket)
      }
      await this.handleJxufeCasCallback()      //江西财经大学(CAS)登录回调
      this.checkXYKeyAndSendRequest()   //上海外国语学院登录信息
      this.Wuhanuniversityengineeringlibrary()   //武汉工程大学图书馆登录信息

      // 登录机构为江西财经大学图书馆时，弹出「荐购规则」提示（同一会话仅一次）
      this.tryShowJiangouRule()
    },

    methods: {
      Wuhanuniversityengineeringlibrary() {
        const hash = window.location.hash
        const hashIndex = hash.indexOf('#');
        if (hashIndex == -1) {
          return;
        }
        const hashPart = hash.slice(hashIndex + 1); // 去掉 #
        const paramsIndex = hashPart.indexOf('?');
        if (paramsIndex == -1) {
          return;
        }
        const paramsPart = hashPart.slice(paramsIndex + 1);
        const urlParams = new URLSearchParams(paramsPart);
        const tokenStr = urlParams.get('token');
        const tokenObj = JSON.parse(tokenStr);
        // console.log(tokenObj, 'tokenObj');

        // 走登录
        Cookies.set('erpGid', tokenObj.data.erpGid)
        Cookies.set('token', tokenObj.data.token)
        Cookies.set('name', tokenObj.data.userName)
        Cookies.set('orgName', tokenObj.data.orgName)
        Cookies.set('UserID', tokenObj.data.gid)
        Cookies.set('orgGid', tokenObj.data.orgGid)
        Cookies.set('passPort', tokenObj.data.passport)
        Cookies.set('adminState', tokenObj.data.adminState)
        this.adminState1 = tokenObj.data.adminState
        Cookies.set('logintype', tokenObj.data.source)
        if (tokenObj.data.adminState == 0 || tokenObj.data.adminState == 1) {
          Cookies.set('source', 0)
        } else {
          Cookies.set('source', 1)
        }
        Cookies.set('shoppingCartPermissions', tokenObj.data.shoppingCartPermissions)
        // 是否登录的一个标识，用来展示导航头的我的购物车/xxx图书馆/xxx登录
        // 更新 Vuex
        this.$store.commit('DataStorage/setUserInfo', {
          name: tokenObj.data.userName,
          adminState: tokenObj.data.adminState,
          orgName: tokenObj.data.orgName,
          orgGid: tokenObj.data.orgGid,
        })
        this.$store.commit('DataStorage/setLoginShowOrNot', false)
        localStorage.setItem('user', JSON.stringify(tokenObj.data));
      },
      async checkXYKeyAndSendRequest() {
        const hash = window.location.hash;
        const paramsPart = hash.split('?')[1];
        // console.log(paramsPart, 'paramsPart');
        if (!paramsPart) {
          console.log('URL 中没有参数');
          return false;
        }
        const params = new URLSearchParams(paramsPart);
        // console.log(params.get('schoolname'), 'params.get');
        const xykey = params.get('schoolname') == 'shwyxy';
        // console.log(xykey, 'xykey');
        if (xykey) {
          // 组织参数对象
          let requestData = {
            hex_time: params.get('hex_time'),
            sign: params.get('sign'),
            id: params.get('id'),
            name: params.get('name'), // 已自动解码
            xykey: params.get('schoolname')
          }
          let res = await getjglogin(requestData)
          if (res.code == 200) {
            // 走登录
            let vm = this;
            Cookies.set('erpGid', res.data.erpGid)
            Cookies.set('token', res.data.token)
            Cookies.set('name', res.data.userName)
            Cookies.set('orgName', res.data.orgName)
            Cookies.set('UserID', res.data.gid)
            Cookies.set('orgGid', res.data.orgGid)
            Cookies.set('passPort', res.data.passport)
            Cookies.set('adminState', res.data.adminState)
            this.adminState1 = res.data.adminState
            Cookies.set('logintype', res.data.source)
            if (res.data.adminState == 0 || res.data.adminState == 1) {
              Cookies.set('source', 0)
            } else {
              Cookies.set('source', 1)
            }
            Cookies.set('shoppingCartPermissions', res.data.shoppingCartPermissions)
            // 是否登录的一个标识，用来展示导航头的我的购物车/xxx图书馆/xxx登录
            this.$store.commit('DataStorage/setUserInfo', {
              name: res.data.userName,
              adminState: res.data.adminState,
              orgName: res.data.orgName,
              orgGid: res.data.orgGid,
            })
            this.$store.commit('DataStorage/setLoginShowOrNot', false)
            localStorage.setItem('user', JSON.stringify(res.data));
          }
        } else {
          console.log('未找到 schoolname');
          return false;
        }
      },
      getTicketFromUrl() {
        // 方法1：使用 URLSearchParams（适用于哈希模式后的参数）
        const hash = window.location.hash
        const queryIndex = hash.indexOf('?')
        if (queryIndex > -1) {
          const queryStr = hash.substr(queryIndex + 1)
          const params = new URLSearchParams(queryStr)
          return params.get('ticket') // 返回解码后的值
        }
        return null
      },
      async showcarsi(ticket) {
        let data = {
          ticket: encodeURIComponent(ticket) // 如果需要保持编码格式
        }
        let res = await getshowcarsi(data)
        if (res.code == 200) {
          // 处理成功逻辑
          //  console.log(res,'ress');
          let vm = this;
          Cookies.set('erpGid', res.data.erpGid)
          Cookies.set('token', ticket)
          Cookies.set('name', res.data.userName)
          Cookies.set('orgName', res.data.orgName)
          Cookies.set('UserID', res.data.gid)
          Cookies.set('orgGid', res.data.orgGid)
          Cookies.set('passPort', res.data.passport)
          Cookies.set('adminState', res.data.adminState)
          this.adminState1 = res.data.adminState
          Cookies.set('logintype', res.data.source)
          if (res.data.adminState == 0 || res.data.adminState == 1) {
            Cookies.set('source', 0)
          } else {
            Cookies.set('source', 1)
          }
          Cookies.set('shoppingCartPermissions', res.data.shoppingCartPermissions)
          // 是否登录的一个标识，用来展示导航头的我的购物车/xxx图书馆/xxx登录
          // vm.$store.state.DataStorage.LoginShowOrNot = false;
          this.$store.commit('DataStorage/setUserInfo', {
            name: res.data.userName,
            adminState: res.data.adminState,
            orgName: res.data.orgName,
            orgGid: res.data.orgGid,
          })
          this.$store.commit('DataStorage/setLoginShowOrNot', false)
          localStorage.setItem('user', JSON.stringify(res.data));
        }
      },
      // 江西财经大学(CAS 统一认证)登录回调：解析地址栏 ?ticket=... 并调 jxcjjglogin 完成登录
      getJxufeTicket() {
        const search = window.location.search
        if (search) {
          return new URLSearchParams(search).get('ticket')
        }
        return null
      },
      async handleJxufeCasCallback() {
        const ticket = this.getJxufeTicket()
        if (!ticket) return
        try {
          const res = await jxcjjglogin({ ticket: encodeURIComponent(ticket) })
          if (res.code == 200) {
            const d = res.data
            Cookies.set('erpGid', d.erpGid)
            Cookies.set('token', d.token)
            Cookies.set('name', d.userName)
            Cookies.set('orgName', d.orgName)
            Cookies.set('UserID', d.gid)
            Cookies.set('orgGid', d.orgGid)
            Cookies.set('passPort', d.passport)
            Cookies.set('adminState', d.adminState)
            Cookies.set('logintype', d.source)
            if (d.adminState == 0 || d.adminState == 1) {
              Cookies.set('source', 0)
            } else {
              Cookies.set('source', 1)
            }
            Cookies.set('shoppingCartPermissions', d.shoppingCartPermissions)
            this.$store.commit('DataStorage/setUserInfo', {
              name: d.userName,
              adminState: d.adminState,
              orgName: d.orgName,
              orgGid: d.orgGid,
            })
            this.$store.commit('DataStorage/setLoginShowOrNot', false)
            localStorage.setItem('user', JSON.stringify(d))
            // 记录本次会话所属机构，供退出登录时判断是否需要同步注销 CAS 服务端
            Cookies.set('loginInstitutionId', '93594341819100163724492670182846')
            this.$message.success('统一认证登录成功')
            // 清理地址栏中的 ticket，避免刷新重复触发
            const url = new URL(window.location.href)
            url.searchParams.delete('ticket')
            window.history.replaceState({}, document.title, url.pathname + url.search + window.location.hash)
          } else {
            this.$message.error((res && res.msg) || '统一认证登录失败')
          }
        } catch (e) {
          this.$message.error('统一认证登录异常，请重试')
        }
      },
      mysource1() {
        Cookies.set('logintype', 1)
      },
      // 江西财经大学图书馆用户进入首页时弹出「荐购规则」
      // 每次进入首页（含刷新）都弹出，避免用户没看就关掉后错过
      tryShowJiangouRule() {
        const orgGid = Cookies.get('orgGid')
        const loginInstitutionId = Cookies.get('loginInstitutionId')
        // CAS 回调后会写 loginInstitutionId；普通登录写 orgGid，任意一个命中即可
        if (orgGid !== JXUFE_INSTITUTION_GID && loginInstitutionId !== JXUFE_INSTITUTION_GID) return
        this.$nextTick(() => { this.jiangouRuleVisible = true })
      },
      // showerweima(file){
      //       this.erweima = !this.erweima
      //   }, 
      // contactus(){
      //   this.contactusphone = !this.contactusphone
      // },
      async how() {
        // 轮播图、热搜词、顶部快捷分类、下方内容分类均来自 homeAreaAll 接口
        try {
          let areaRes = await homeAreaAll({})
          if (areaRes.code == 200) {
            const d = areaRes.data || {}
            this.overlistbanner = {
              banner: d.banner || [],
              hotwords: d.hotwords || []
            }
            this.carouselAfter = d.carouselAfter || []
            this.tileArea = d.tileArea || []
            this.privateArea = d.privateArea || []
            this.activeChild = {}
            this.homeContentAreas.forEach(area => {
              if (this.hasAreaChildren(area)) this.$set(this.activeChild, area.tagid, 0)
            })
          }
        } catch (e) {
          console.error('homeAreaAll 请求失败', e)
        } finally {
          this.areaLoading = false
        }
      },

      hasAreaChildren(area) {
        return !!(area && area.children && area.children.length)
      },
      // children 为空展示父分类 goods；children 不为空展示当前子分类 goods
      getBlockGoods(area) {
        if (this.hasAreaChildren(area)) {
          const idx = this.activeChild[area.tagid] || 0
          const child = area.children[idx] || area.children[0]
          return (child && child.goods) || []
        }
        return (area && area.goods) || []
      },
      selectChild(area, child, index) {
        this.$set(this.activeChild, area.tagid, index)
      },
      scrollAreaChildren(tagid, direction) {
        const ref = this.$refs['areaLevelClass-' + tagid]
        const element = Array.isArray(ref) ? ref[0] : ref
        if (element) element.scrollLeft += direction * 200
      },



      jingguo(item, value) {
        this.leveListindex = value
        this.zxList = item.goods

      },
      gotucaihui() {
        Cookies.set('logintype', 0)
        this.$router.push({ name: "HomePage" },)
      },



      rexiaojinru(item, value) {
        this.leveListindexCopy = value
        this.zxListCopy = item.goods

      },
      rexiaojinruCopy(item, value) {
        this.leveListindexCopyCopy = value
        this.zxListCopyCopy = item.goods
      },




      openFullScreen2() {
        this.loading = this.$loading({
          target: "body",
          spinner: "el-icon-loading",
          text: "加载中...",
          background: "rgba(255, 255, 255, 0.5)"
        });
      },

      xuanzefenlei(value) {
        this.GuJiaPing = true
        this.oneclassState = value
        if (value == '中图法分类') {
          this.zhongtufa()
        } else if (value == '学科分类') {
          this.zhongtufatwo()
        } else if (value == '大众分类') {
          this.zhongtufathree()

        }
      },
      async zhongtufa() {
        // this.openFullScreen2()
        let data = {
          classifyLevel: 1,
          gid: '',
          all: '100',
          timestamp: 1709618279386,
          signature: '6f2405679d271130fb8a28fdcc79dd20',
        }
        let res = await listclassifyTypes(data)
        if (res.code == 200) {
          this.classList = res.data
          this.classList.map((item) => {
            item.name = item.classifyTypeName
          })
          this.GuJiaPing = false
          // this.loading.close();

        }

      },
      async zhongtufatwo() {
        let data = {
          classifyLevel: 1,
          gid: '',
          all: '100',
          timestamp: 1709618279386,
          signature: '6f2405679d271130fb8a28fdcc79dd20',
        }
        let res = await searchlist(data)
        if (res.code == 200) {
          this.classList = res.data
          this.classList.map((item) => {
            item.name = item.subjectName
            item.children.map((o) => {
              o.classifyTypeName = o.subjectName
            })
            item.cHildrenCopy = item.children.slice(0, 2)
          })
          this.GuJiaPing = false
        }

      },
      async zhongtufathree() {
        // this.openFullScreen2()

        let data = {
          classifyLevel: 1,
          gid: '',
          all: '100',
          timestamp: 1709618279386,
          signature: '6f2405679d271130fb8a28fdcc79dd20',
        }
        let res = await listpopularTypes(data)
        if (res.code == 200) {
          this.classList = res.data
          this.classList.map((item) => {
            item.name = item.typeName
            item.children.map((o) => {
              o.classifyTypeName = o.typeName
            })
          })
          // this.loading.close();

          this.GuJiaPing = false

        }

      },


      shangxiahuadong(item) {
        this.zibiaoqianList = item

        this.twoclassstate = true
      },
      yichu() {
        this.twoclassstate = false
        // this.zibiaoqianList= []

      },
      jinru() {
        this.twoclassstate = true

      },
      BookTuiClickRowid(id, eventId) {
        if (this.$route.params.baseid && !Cookies.get('token')) {
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        } else {
          if (Cookies.get('token')) {
            //添加埋点
            let doId = +localStorage.getItem('doId') + 1,
              params = {
                goodsId: id
              };
            localStorage.setItem('doId', doId);
            //新页面打开书目详情
            const { href } = this.$router.resolve({
              name: 'BookDetail',
              params: { goodsId: id }
            });
            window.open(href, "_blank");
          } else {
            this.$router.push({ name: 'Login' });
          }
        }
      },
      // 特色专区 （图采会专栏、类目）
      TESEtuijianTo(activityTag, name, eventId) {
        if (this.$route.params.baseid && !Cookies.get('token')) {
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        } else {
          if (Cookies.get('token')) {
            if (activityTag == 52) {
              Cookies.set('logintype', 0)
              this.$router.push({ name: "HomePage" },)
              return
            }
            let params = {
              gid: '0',
              TitleName: name,
              publicType: '', // 大众分类
              cnIbraryType: '', // 中图分类
              subjectId: '', // 学科类别
              activityTag: activityTag, // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
              // activityTag: '', // 经典珍藏/重磅推荐/乐活趣览
              goodsType: 1,
              eventId: eventId
            };
            if (this.logintype == 0) {
              const { href } = this.$router.resolve({
                name: 'LookPublishingPagesType',
                query: { obj: JSON.stringify(params) }
              });
              window.open(href, "_blank");
            } else {
              const { href } = this.$router.resolve({
                name: 'LookPublishingPagesTypecopy',
                query: { obj: JSON.stringify(params) }
              });
              window.open(href, "_blank");
            }

          } else {
            this.$router.push({ name: 'Login' });
          }
        }
      },
      // 中图分类
      ChinesClick(item, index) {
        if (index == '中图法分类') {
          this.ztf(item)
        } else if (index == '学科分类') {
          this.xueke(item)
        } else if (index == '大众分类') {
          this.AllClick(item)
        }
      },

      ztf(item) {
        if (this.$route.params.baseid && !Cookies.get('token')) {
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        } else {
          let params = {
            gid: '0',
            zttitle: item.classifyTypeName,
            publicType: '', // 大众分类
            cnIbraryType: item.classifyTypeCode, // 中图分类
            subjectId: '', // 学科类别
            activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            // activityTag: '', // 经典珍藏/重磅推荐/乐活趣览
            goodsType: 1,
          };
          if (this.logintype == 0) {
            const router = this.$router.resolve({
              path: '/LookPublishingPagesType',
              query: {
                obj: JSON.stringify(params),
              }
            })
            window.open(router.href)
          } else {
            const router = this.$router.resolve({
              path: '/LookPublishingPagesTypecopy',
              query: {
                obj: JSON.stringify(params),
              }
            })
            window.open(router.href)
          }

        }
      },
      xueke(item) {
        if (this.$route.params.baseid && !Cookies.get('token')) {
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        } else {
          let params = {
            gid: '0',
            xuekeTitle: item.subjectName,
            publicType: '', // 大众分类
            cnIbraryType: '', // 中图分类
            subjectId: item.subjectCode, // 学科类别
            goodsType: 1
          };
          if (this.$route.query.hasOwnProperty('activitytag')) {
            params.activityTag = this.$route.query.activitytag; //10118        三新现货库存
          } else {
            params.activityTag = '';
          }
          if (this.logintype == 0) {
            const router = this.$router.resolve({
              path: '/LookPublishingPagesType',
              query: {
                obj: JSON.stringify(params),
              }
            })
            window.open(router.href)
          } else {
            const router = this.$router.resolve({
              path: '/LookPublishingPagesTypecopy',
              query: {
                obj: JSON.stringify(params),
              }
            })
            window.open(router.href)
          }


        }

      },
      AllClick(item) {
        if (this.$route.params.baseid && !Cookies.get('token')) {
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        } else {
          let params = {
            gid: '0',
            title: item.typeName,
            publicType: item.typeCode, // 大众分类
            cnIbraryType: '', // 中图分类
            subjectId: '', // 学科类别
            activityTag: '', // 1精品大码洋/2畅销书/3医学/4抗疫图书/5少儿专区/6推荐书单/7工具书
            goodsType: 1
          };
          if (this.logintype == 0) {
            const router = this.$router.resolve({
              path: '/LookPublishingPagesType',
              query: {
                obj: JSON.stringify(params),
              }
            })
            window.open(router.href)
          } else {
            const router = this.$router.resolve({
              path: '/LookPublishingPagesTypecopy',
              query: {
                obj: JSON.stringify(params),
              }
            })
            window.open(router.href)
          }

        }
      },

      erjitiaozhuan(item) {
        if (this.oneclassState == '中图法分类') {
          this.ztf(item)
        } else if (this.oneclassState == '学科分类') {
          this.xueke(item)
        } else if (this.oneclassState == '大众分类') {
          this.AllClick(item)

        }
      },
      guding(item) {
        this.AllClick(item)

      },
      toSearchList() {
        if (this.$route.params.baseid && !Cookies.get('token')) {
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        } else {
          if (Cookies.get("token")) {
            if (this.logintype == 0) {
              const router = this.$router.resolve({
                path: "LookPublishingPagesType",
                query: { obj: JSON.stringify({ modeChange: 2, gid: 0 }) },
              });
              window.open(router.href)
            } else {
              const router = this.$router.resolve({
                path: "LookPublishingPagesTypecopy",
                query: { obj: JSON.stringify({ modeChange: 2, gid: 0 }) },
              });
              window.open(router.href)
            }

          } else {
            this.$router.push({ name: "Login" });

          }
        }
      },
      toSearchListCopy(time) {
        if (this.$route.params.baseid && !Cookies.get('token')) {
          this.$router.push({ name: "Login", params: { baseid: this.$route.params.baseid } });
        } else {
          if (Cookies.get("token")) {
            if (this.logintype == 0) {
              const router = this.$router.resolve({
                path: "LookPublishingPagesType",
                query: { obj: JSON.stringify({ sousuoName: time }) },
              });
              window.open(router.href)
            } else {
              const router = this.$router.resolve({
                path: "LookPublishingPagesTypecopy",
                query: { obj: JSON.stringify({ sousuoName: time }) },
              });
              window.open(router.href)
            }

          } else {
            this.$router.push({ name: "Login" });
          }
        }
      },
      multiAdd(type, item) {
        let vm = this;
        if (Cookies.get("token")) {
          vm.addCarbyBooks(type, item);

        } else {
          localStorage.setItem('pageUrl', `/${window.location.hash}`);
          vm.$router.push({
            name: "Login"
          });
        }
      },
      //批量或单个加入荐购
      addCarbyBooks(goodsId, item) {
        let checkedList = [];
        checkedList.push(goodsId);
        let vm = this,
          obj = {
            goodsIdList: checkedList,
            userId: Cookies.get("UserID"),
            source: Cookies.get("source"),
            amount: 1
          };
        vm.beforeAddCar(obj).then(function (obj) {
          addMoreOrder(obj).then(res => {
            if (res.status) {
              // 处理不同区域的商品状态更新
              if (item == 'types') {
                // 处理types区域
                vm.overlistbanner.types.forEach(type => {
                  type.goods.forEach(book => {
                    if (book.goodsId == goodsId) {
                      vm.$set(book, 'selectNum', 1);
                    }
                  });
                });
              } else if (item == 'classList') {
                // 处理最新上架区域
                vm.overlistbanner.classList.forEach(typeclassList => {
                  typeclassList.goods.forEach(bookclass => {
                    if (bookclass.goodsId == goodsId) {
                      vm.$set(bookclass, 'selectNum', 1);
                    }
                  });
                });
              } else if (item == 'salesRank') {
                // 处理动销排行区域（对应zxListCopy）
                vm.overlistbanner.groupname[0].v.forEach(groupItem => {
                  groupItem.goods.forEach(book => {
                    if (book.goodsId == goodsId) {
                      vm.$set(book, 'selectNum', 1);
                    }
                  });
                });
              } else if (item == 'themeRecommend') {
                // 处理主题推荐区域（对应zxListCopyCopy）
                vm.overlistbanner.groupname[1].v.forEach(groupItem => {
                  groupItem.goods.forEach(book => {
                    if (book.goodsId == goodsId) {
                      vm.$set(book, 'selectNum', 1);
                    }
                  });
                });
              } else if (item == 'carouselAfter') {
                // 处理轮播图上方快捷分类关联图书
                vm.markAreaSelected(vm.carouselAfter, goodsId)
              } else if (item == 'tileArea') {
                // 处理下方平铺公共分类区域
                vm.markAreaSelected(vm.tileArea, goodsId)
              } else if (item == 'privateArea') {
                // 处理当前机构个性化分类区域
                vm.markAreaSelected(vm.privateArea, goodsId)
              }
              if (vm.adminState1 == 0 || vm.adminState1 == 1) {
                vm.$message({
                  message: '加入购物车成功',
                  type: 'success',
                  duration: 800
                });
              } else if (vm.adminState1 == 2 || vm.adminState1 == 3 || vm.adminState1 == 4 || vm.adminState1 == 5) {
                vm.$message({
                  message: '荐购成功',
                  type: 'success'
                });
              }
              vm.getShopCarData()   // 更新购物车数据                    
              // vm.DiFangData(vm.params);
            } else if (res.code == '10000') {
              vm.$confirm('您还没有收货地址，需要设置收货地址才可以荐购，需要设置吗？', '提示', {
                confirmButtonText: '前往设置',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                vm.goChangeAddress();
              }).catch(() => {

              });
            }
          }).catch(err => {
            vm.$message({
              message: err.res.errorMsg,
              type: 'error',
              duration: 800
            });
          });

        })
      },
      // 在采购分类三区域中标记某本书已加入（递归遍历父/子分类的 goods）
      markAreaSelected(areaList, goodsId) {
        const vm = this
        ;(areaList || []).forEach(tag => {
          ;(tag.goods || []).forEach(book => {
            if (book.goodsId == goodsId) vm.$set(book, 'selectNum', 1)
          })
          ;(tag.children || []).forEach(child => {
            ;(child.goods || []).forEach(book => {
              if (book.goodsId == goodsId) vm.$set(book, 'selectNum', 1)
            })
          })
        })
      },
      beforeAddCar(obj) {
        return new Promise((resolve, reject) => {
          let vm = this;
          Axios.post('/goods/action/check', { params: JSON.stringify(obj.goodsIdList) },
            {
              headers: {
                "Content-Type": "application/json"
              }
            }
          ).then(res => {
            let datalist = res.data || {};
            if (datalist.duplicateList && datalist.duplicateList.length > 0) {//无重复
              vm.$confirm("重复采购，是否继续提交？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "warning"
              }).then(() => {
                //全部数组
                resolve(obj)
              }).catch(() => { });

            } else {//有重复
              resolve(obj)
            }
          });
        });
      },
      // 展示购物车数据
      async getShopCarData() {
        let data = {
          userId: Cookies.get("UserID"),
        };
        let res = await shoppingCartnum(data)
        if (res.code == '200') {
          this.$store.state.DataStorage.GoodLengthData = res.data;
        }
      },
      goChangeAddress() {
        let vm = this;
        vm.edit_pop = popup('<address-manage @close="close" @submit="submit" :changetype="type" />', {
          option: {
            title: '切换默认地址',
            width: '800px'
          },
          popup: {
            data() {
              return {
                type: 0, //0：切换默认地址
              };
            },
            components: {
              addressManage
            },
            methods: {
              submit(data) {
                vm.defaultAddress = data.address;
                vm.edit_pop.hide();
              },
              close() {
                vm.edit_pop.hide();
              }
            }
          }
        });
        vm.edit_pop.show();
      },

      //客户问题反馈
      //  ProblemReport() {
      //       if (Cookies.get("token")) {
      //           const { href } = this.$router.resolve({
      //             name: 'ProblemReport',
      //          });
      //       window.open(href, '_blank');
      //       } else {
      //           this.$router.push({ name: "Login" });
      //       }
      //   },




      nextList() {
        var container = document.querySelector('.levelClass');
        container.scrollLeft += 500; // 设置滚动距离
      },
      preList() {
        var container = document.querySelector('.levelClass');
        container.scrollLeft -= 500; // 设置负值滚动距离，实现往左滚动
      },
      nextListCopy() {
        var container = document.querySelector('.levelClassCopy');
        container.scrollLeft += 500; // 设置滚动距离
      },
      preListCopy() {
        var container = document.querySelector('.levelClassCopy');
        container.scrollLeft -= 500; // 设置负值滚动距离，实现往左滚动
      }, nextListCopyCopy() {
        var container = document.querySelector('.levelClassCopyCopy');
        container.scrollLeft += 500; // 设置滚动距离
      },
      preListCopyCopy() {
        var container = document.querySelector('.levelClassCopyCopy');
        container.scrollLeft -= 500; // 设置负值滚动距离，实现往左滚动
      },

    }
  }
</script>



<style scoped lang='scss'>
  .header {
    width: 100%;
    background-color: #fff;
    border-bottom: 3px solid #ca1a1b;
  }

  .header_sousuo {
    width: 1224px;
    margin: 0 auto;
  }

  .shenzi {
    width: 1224px;
    margin: 0 auto;
  }

  .shenzi_left {
    width: 76%;
    min-height: 160px;
    box-sizing: border-box;
    // height: 100px;
    // border: 1px solid #e4e4e4;
  }

  .sjemzo_right {
    width: 21%;
    height: 400px;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 20px;
    margin-left: 2%;
    padding: 20px;
  }

  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }

  .sjemzo_right_new {
    display: flex;
    justify-content: space-between;
  }

  .sjemzo_right_new_over {
    color: #8e7054;
    font-size: 13px;
    height: 35px;
    line-height: 35px;
    position: relative;
    left: -10px;
    font-weight: normal;
    cursor: pointer;
  }

  .sjemzo_right_new_overon {
    color: #8e7054;
    font-size: 13px;
    height: 50px;
    line-height: 50px;
    position: relative;
    font-weight: normal;
    cursor: pointer;
  }

  .sjemzo_right_new_qun {
    color: #343434;
    float: left;
    font-size: 18px;
    font-weight: bold;
    line-height: 30px;
    height: 35px;
  }

  .sjemzo_right_xinwen {
    width: 100%;
    height: 85%;
  }

  .sjemzo_right_xinwen_url {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-top: 10px;
    font-size: 13px;
  }

  .zdtj {
    width: 100%;
    margin-top: 60px;
  }

  .zdtj_next {
    font-family: '思源黑体';
    /* text-indent: 1.9em; */
    font-size: 20px;
    font-weight: 800;
    height: 50px;
    line-height: 50px;
  }

  .levelClass {
    width: 88%;
    overflow: hidden;
    display: -webkit-box;
    margin-top: 10px;
    // align-items: center; /* 垂直居中 */
    // justify-content: space-around;

    //   overflow-x: auto;
  }

  .levelClassCopy {
    width: 88%;
    overflow: hidden;
    display: -webkit-box;
    margin-top: 10px;
  }

  .levelClassCopyCopy {
    width: 88%;
    overflow: hidden;
    display: -webkit-box;
    margin-top: 10px;
  }

  .levelClass_list {
    margin-left: 10px;
    display: block;
    cursor: pointer;
    text-align: center;
    line-height: 35px;
    height: 35px;
    color: #5c5052;
    background: white;
    border-radius: 5px;
    padding: 0px 18px;
    font-size: 12px;
  }

  .levelClass_liston {
    margin-left: 10px;

    display: block;
    cursor: pointer;
    text-align: center;
    line-height: 35px;
    height: 35px;
    color: #fff;
    background: #ca1a1b;
    border-radius: 5px;
    padding: 0px 18px;
    font-size: 12px;
  }

  .zdtj_overlist {
    width: 100%;
    height: 305px;
    display: flex;
    justify-content: space-between;
    // display: -webkit-box;
  }

  .zdtj_overlist_list {
    position: relative;
    width: 190px;
    height: 350px;
    background: white;
    border-radius: 5px;
    text-align: center;
    color: #666666;
    transition: transform 0.2s, box-shadow 0.2s;
    /* 添加过渡效果 */
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    /* 添加阴影效果 */
  }

  .orderedTip {
    font-size: 12px;
    display: inline-block;
    position: absolute;
    right: 0;
    top: 0;
    padding: 3px 5px;
    background-color: #E6A23C;
    color: #fff;
  }

  .zdtj_overlist_list:hover {
    transform: translateY(-3px);
    /* 鼠标进入时上移5像素 */
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
    /* 鼠标进入时增加阴影 */
  }

  .zxsj {
    width: 100%;
    margin-top: 60px;
  }

  .zxsj_top {
    display: flex;
    justify-content: space-between;
  }

  .zxsj_list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .zxsj_list_over {
    position: relative;
    width: 24%;
    height: 225px;
    background: white;
    border-radius: 5px;
    margin-top: 10px;
    display: flex;
    cursor: pointer;
    transition: transform 0.2s, box-shadow 0.2s;
    /* 添加过渡效果 */
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    /* 添加阴影效果 */
  }

  .zxsj_list_over:hover {
    transform: translateY(-3px);
    /* 鼠标进入时上移5像素 */
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
    /* 鼠标进入时增加阴影 */
  }

  .zxsj_list_over_right {
    margin-top: 30px;
    width: 133px;

    .class1 {
      width: 100%;
      font-size: 14px;
      margin-bottom: 5px;
      color: #825d59;
      font-weight: 800;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .class2 {
      color: #666666;
      font-size: 12px;
      width: 100%;
      white-space: initial;
      float: left;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 5px;
    }

    .zxsj_text {
      color: #666666;
      font-size: 12px;
      width: 100%;
      white-space: initial;
      float: left;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 5px;
    }
  }

  .box_list {
    font-size: 12px;
    max-height: 20px;
    overflow: hidden;
    line-height: 20px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #d3dce6;
  }

  .oneclass {
    width: 24%;
    height: 100%;
    background-color: #fff;
    padding-bottom: 6px;
    // padding-left: 10px;
    // padding-right: 10px;
    // width: calc(24% - 30px);
  }

  .oneclass_kuai {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  .oneclass_xuanz {
    display: flex;
    position: -webkit-sticky;
    /* 兼容性处理，适用于iOS Safari */
    position: sticky;
    top: 0;
    /* 元素吸顶时距离顶部的距离 */
    z-index: 1000;
    /* 可选，控制元素在吸顶时的堆叠顺序 */
    /* 其他样式，根据您的需求自行添加 */
  }

  .oneclass_class {
    cursor: pointer;
    width: 34%;
    height: 40px;
    background-color: #fff;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    color: #333;
    display: flex;
    justify-content: center;
  }

  .oneclass_classon {
    cursor: pointer;
    width: 34%;
    height: 40px;
    background-color: #fff;
    line-height: 40px;
    font-size: 14px;
    text-align: center;
    color: #ca1a1b;
    display: flex;
    justify-content: center;
  }

  .oneclass_kuai::-webkit-scrollbar {
    display: none;
  }

  .fudong_text {
    font-size: 17px;
    font-weight: 800;
    color: #333;
    padding: 10px;
  }

  .fudong_textneirong {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }

  .textneirong {
    cursor: pointer;
    padding: 10px;
    font-size: 12px;
    background-color: #fff0f0;
    margin-right: 10px;
    margin-top: 10px;
  }

  .textneirong:hover {
    // background-color: #ffffff;
    text-decoration: underline;
    font-weight: bold;
    color: #CA1A1B;
  }

  .oneclass_yiji {
    font-size: 13px;
    width: 100%;
    padding: 5px 0px 5px 8px;
    height: 28px;
    line-height: 28px;
    white-space: nowrap; //不换行
    overflow: hidden; //超出部分隐藏
    text-overflow: ellipsis; //文本溢出显示省略号
    // border-bottom: 1px solid #e4e4e4;
  }

  .oneclass_yijion {
    font-size: 13px;
    width: 100%;
    background-color: #fff0f0;
    padding: 5px 0px 5px 8px;
    height: 28px;
    line-height: 28px;
    white-space: nowrap; //不换行
    overflow: hidden; //超出部分隐藏
    text-overflow: ellipsis; //文本溢出显示省略号
    // border-bottom: 1px solid #e4e4e4;
  }

  .searchcontainer {
    width: 90%;
    /* 设置搜索框容器的宽度 */
    border: 2px solid #ca1a1b;
    display: flex;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .searchcontainer input {
    border: none;
    padding: 10px;
    width: 87%;
    // border: 2px solid red;
    // border-radius: 6px;
    font-size: 14px;

    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    outline: none;
  }

  .banner-box {
    img {
      // width: 1310px;
      height: 410px;
      border-radius: 4px;
    }
  }

  .tuijian {
    cursor: pointer;
    font-size: 14px;
    font-weight: 800;
  }

  .tuijian:hover {
    color: red;
    font-weight: 800;
  }

  .ceshi {
    margin-top: 40px;
  }

  .typenames {
    font-size: 13px;
    width: 93%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .typenames:hover {
    color: #CA1A1B;
  }

  .sidenavigationbar {
    background-color: #fff;
    position: fixed;
    top: 36%;
    right: 0px;
    justify-content: center;
    width: 90px;
    /* height: 360px; */
  }

  .sidenavigationbaritem {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    border-top: 1px solid #dcdcdc;
    border-left: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    border-right: 1px solid #ffe6e6;
    cursor: pointer;
    width: 100%;
    height: 80px;
    font-size: 14px;

  }
</style>


// WEBPACK FOOTER //
// src/views/Xtch/Xindex.vue